import styled from 'styled-components'

import { colors } from '../../styles/colors'

interface ILoadingProps {
  color?: string
}

export const Loading = styled.div<ILoadingProps>`
  width: 100px;
  height: 100px;
  border: 10px solid ${colors.blue};
  border-top-color: #0e0e0e;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  ${props => props.color && `border-top-color: ${props.color}`};

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`
export const Title = styled.span`
  color: ${colors.white};
  font-size: 14px;
  font-weight: 700;
  margin-top: 32px;
`
export const ContainerBackdrop = styled.div`
  height: calc(100% + 101px);
  z-index: 999;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: black;
  opacity: 0.8;
`
export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
